var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRandomIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.747
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#232586",
    rx: 50,
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_10495",
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#fff",
    rx: 50
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    stroke: "#fff",
    rx: 50
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_10495)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M42.6889 17.1257L38.6984 21.106C38.4339 21.3698 38.4339 21.7963 38.6984 22.0601C38.9629 22.3239 39.3904 22.3239 39.6549 22.0601L42.559 19.1634V21.583C42.559 25.9513 46.4676 29.1415 50.2484 32.2264C53.9474 35.2452 57.4413 38.0973 57.4413 41.8253C57.4413 42.1977 57.7437 42.5 58.1178 42.5C58.4919 42.5 58.7943 42.1977 58.7943 41.8253C58.7943 37.457 54.8856 34.2668 51.1048 31.1819C47.4059 28.1631 43.9119 25.3123 43.9119 21.583V19.2592L46.8241 22.0682C47.0927 22.3273 47.5209 22.3199 47.7807 22.0527C47.9078 21.9211 47.9708 21.7517 47.9708 21.583C47.9708 21.4063 47.9018 21.2308 47.7644 21.0979L43.8409 17.314C43.732 17.0872 43.504 16.928 43.2355 16.928C43.2226 16.928 43.2125 16.9348 43.2003 16.9354C43.0163 16.926 42.8296 16.9854 42.6889 17.1257Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M56.1588 17.3139L52.2353 21.0979C51.9674 21.3563 51.9606 21.7834 52.2197 22.052C52.4795 22.3192 52.9077 22.3266 53.1762 22.0675L56.0884 19.2592V21.583C56.0884 23.672 55.0196 25.6402 52.6236 27.9654C52.3557 28.2258 52.3489 28.6523 52.61 28.9195C52.8705 29.1867 53.2994 29.1927 53.5666 28.933C56.2461 26.3325 57.4414 24.0661 57.4414 21.583V19.1634L60.3455 22.0601C60.61 22.3239 61.0375 22.3239 61.302 22.0601C61.4339 21.9285 61.5002 21.7558 61.5002 21.583C61.5002 21.4103 61.4339 21.2376 61.302 21.106L57.3115 17.1257C57.1708 16.9853 56.9848 16.926 56.8001 16.9354C56.7879 16.9347 56.7778 16.928 56.7649 16.928C56.4957 16.928 56.2684 17.0872 56.1588 17.3139Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M42.559 41.8253C42.559 41.44 42.5976 41.0527 42.6726 40.6742C43.1523 38.2552 45.16 36.1932 46.8559 34.6669C47.0041 34.534 47.0792 34.3505 47.0792 34.1656C47.0792 34.0043 47.0217 33.8424 46.9046 33.7142C46.6543 33.4376 46.2268 33.416 45.9495 33.6656C44.0986 35.3316 41.9028 37.6041 41.3454 40.4124C41.2527 40.8766 41.2061 41.3523 41.2061 41.8253C41.2061 42.1977 41.5091 42.5 41.8825 42.5C42.2559 42.5 42.559 42.1984 42.559 41.8253Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomIcon);
export default __webpack_public_path__ + "static/media/random_icon.faf5ad6150e0351a7308e0ec5a02aeaf.svg";
export { ForwardRef as ReactComponent };